export const formatLykCoins = (value: unknown) => {
  const num = Number(value)
  if (!Number.isFinite(num)) return 0
  const rounded = Math.ceil(num - 0.5)
  return Object.is(rounded, -0) ? 0 : rounded
}

export const formatLykCoinValue = (value: unknown, exchangeRate = 0.02) => {
  const lykCoinBalance = formatLykCoins(value)
  return (lykCoinBalance * exchangeRate).toFixed(2)
}
